import { SSO_CALLBACK_BROADCAST_CHANNEL, TESTWE_API } from "core/constants"
import { SSO_CALLBACK } from "core/deeplinks.json"
import { Token } from "types"

export function ssoLogin(
  username: string,
  establishmentUuid: string,
  rememberMe: boolean,
): Promise<Token> {
  const url = new URL(`${TESTWE_API}/login/sso`)

  url.searchParams.set("establishmentUuid", establishmentUuid)
  url.searchParams.set("redirectUri", `${window.location.origin}/#/${SSO_CALLBACK}`)
  url.searchParams.set("username", username || "undefined")
  url.searchParams.set("rememberMe", rememberMe.toString())

  return new Promise<Token>((resolve, reject) => {
    const win = window.open(url.toString(), "_blank")

    const bc = new BroadcastChannel(SSO_CALLBACK_BROADCAST_CHANNEL)

    bc.onmessage = (event) => {
      try {
        const urlObj = new URL(event.data)
        const token = urlObj.searchParams.get("accessToken")
        const refreshToken = urlObj.searchParams.get("refreshToken")

        if (token && refreshToken) {
          resolve({ token, refreshToken })
        } else {
          window.electron.log.error("error", "SSO | Missing tokens in broadcast message")
          reject(new Error("MISSING_TOKENS"))
        }
      } catch (error) {
        reject(error)
      } finally {
        bc.close()
        win?.close()
      }
    }
  })
}

export function detectSSOTokensForBrodcast(): boolean {
  const urlParams = new URLSearchParams(window.location.href.split("?")[1])
  const accessToken = urlParams.get("accessToken")
  const refreshToken = urlParams.get("refreshToken")

  if (accessToken && refreshToken) {
    const url = new URL(window.location.href)
    url.searchParams.delete("accessToken")
    url.searchParams.delete("refreshToken")
    window.history.replaceState({}, document.title, url.toString())

    const bc = new BroadcastChannel(SSO_CALLBACK_BROADCAST_CHANNEL)
    bc.postMessage(
      `${window.location.origin}/?accessToken=${accessToken}&refreshToken=${refreshToken}`,
    )
    bc.close()

    return true
  }

  return false
}
